import { FC } from 'react'
import { SectionArticleAuthorProps } from '@portfolio/models'
import { styled } from '@portfolio/styles'
import {
  Container,
  Media,
  PortableText,
  SectionWrapper,
} from '@portfolio/components'
import { useTranslation } from 'react-i18next'
import Link from 'next/link'

const Wrap = styled('div', {
  padding: '$24 0 $32 0',
  borderTop: '1px solid $black',
  borderBottom: '1px solid $black',
  '@lg': {
    padding: '$32 0 $48 0',
  },
})

const AuthorsWrapper = styled('div', {
  display: 'grid',
  gridAutoFlow: 'row',
  justifyContent: 'start',
  gridRowGap: '$40',
  gridColumnGap: '$40',
})

const Author = styled('div', {
  display: 'grid',
  gridTemplate: `
                'avatar details'
                '. description'
              `,
  alignItems: 'center',
  gridTemplateColumns: '60px auto',
  gridRowGap: '$8',
  gridColumnGap: '$32',
})

const Title = styled('p', {
  textTransform: 'uppercase',
  projectFont: 'ui03',
  marginBottom: '$32',
})
const Avatar = styled('div', {
  overflow: 'hidden',
  borderRadius: '$rMax',
  width: 60,
  height: 60,
  gridArea: 'avatar',
})

const Name = styled('p', {
  projectFont: 'ui01',
})
const Positon = styled('p', {
  projectFont: 'body04',
  color: '$black_05',
})
const Details = styled('div', {
  gridArea: 'details',
})

const Description = styled('div', {
  gridArea: 'description',
  projectFont: 'body04',
  maxWidth: '70ch',
  color: '$white',
})

export const SectionArticleAuthor: FC<SectionArticleAuthorProps> = ({
  authors,
}) => {
  const { t } = useTranslation('article')
  return (
    <SectionWrapper type="RICH_TEXT_MD">
      <Container>
        <Wrap>
          <Title>{t('writtenBy')}</Title>
          <AuthorsWrapper>
            {authors &&
              authors?.map((author, index) => (
                <Author
                  as={author?.linkedin ? Link : 'div'}
                  href={author?.linkedin}
                  target="_blank"
                  key={`${author?.name}-${index}`}
                >
                  <Avatar>
                    {author?.avatar && (
                      <Media {...author?.avatar} sizes="60px" />
                    )}
                  </Avatar>
                  <Details>
                    <Name>{author?.name}</Name>
                    <Positon>{author?.position}</Positon>
                  </Details>
                  {author?.description && (
                    <Description>
                      <PortableText
                        value={author?.description}
                        appearance="plain"
                      />
                    </Description>
                  )}
                </Author>
              ))}
          </AuthorsWrapper>
        </Wrap>
      </Container>
    </SectionWrapper>
  )
}
